import { Outlet } from "react-router"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { TabContent, Tabs, TabsList } from "@sembark-travel/ui/base"
import { generatePath } from "../../../../router-utils"
import { NavLink } from "@sembark-travel/ui/router"

export default function Layout() {
	return (
		<ForbidUnlessAuthorized anyPermissions={[PERMISSIONS.MANAGE_TENANTS]}>
			<Tabs layout="col">
				<TabsList>
					<NavLink to={generatePath("/admin/pg/transactions")}>
						Transactions
					</NavLink>
					<NavLink to={generatePath("/admin/pg/settlements")}>
						Settlements
					</NavLink>
					<NavLink to={generatePath("/admin/pg/payment-links")}>
						Payment Links
					</NavLink>
				</TabsList>
				<TabContent>
					<Outlet />
				</TabContent>
			</Tabs>
		</ForbidUnlessAuthorized>
	)
}
